import styled from 'styled-components';

export const OfferCouponContainer = styled.div`
    .bt-fifth {
        padding: 7px;

        .bt-text .svg-container {
            margin-left: auto;
            width: 17px;
            height: 20px;
            overflow: hidden;

            .svg {
                width: 17px;
                height: 20px;
            }
            .svg-check path {
                stroke: ${props => props.theme.brandBrimary};
            }
            path.svg-copy-paste {
                fill: ${props => props.theme.interstitielCopyPasteSvgColor};
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/interstitiel/offer/CouponOfferComponentStyle.js